import type { MockServer } from './server'
import { isBefore } from '@/utils/date/validation.js'

export function routes(server: MockServer) {
  server.get(
    '/patient_locations/:id/available_capacity',
    function (db, request) {
      const patientLocationId = request.params.id

      const currentBoardingEvent = request.queryParams.boarding_event_id
        ? db.find(
            'boardingEvent',
            request.queryParams.boarding_event_id.toString(),
          )
        : undefined

      const requestStartTime = request.queryParams.start_time as string
      const requestEndTime = request.queryParams.end_time as string

      const currentLocation = db.findBy('patientLocation', {
        id: patientLocationId,
      })

      const checkOverlapping = (startTime: string, endTime: string) => {
        return (
          (isBefore(requestStartTime, endTime) &&
            !isBefore(requestStartTime, startTime)) ||
          (isBefore(requestStartTime, startTime) &&
            !isBefore(requestEndTime, endTime)) ||
          (isBefore(requestStartTime, startTime) &&
            !isBefore(requestEndTime, startTime)) ||
          (requestEndTime === endTime && requestStartTime === startTime)
        )
      }

      const patientLocationOverlappingEvents = db
        .all('boardingEvent')
        .filter(
          (event) =>
            event.patientLocationId === patientLocationId &&
            event.id !== currentBoardingEvent?.attrs.id,
        )
        .filter((event) =>
          checkOverlapping(
            event.attrs.start as string,
            event.attrs.end as string,
          ),
        )

      const availableCapacity = currentLocation?.attrs.capacity
        ? currentLocation.attrs.capacity -
          patientLocationOverlappingEvents.models.length
        : undefined

      return {
        data: {
          type: 'PatientLocationAvailableCapacity',
          id: patientLocationId,
          attributes: {
            available_capacity: availableCapacity,
          },
        },
      }
    },
  )
}

export function seeds(server: MockServer) {
  return server.lazySeedingManager?.seedBasic('PatientLocation')
}
